export default __webpack_public_path__ + "static/media/Spectre.52523684.mp3";